import service from "./service"

const savePreCheckConsentProgress = async (data) => {
    return service(data)
}

export default savePreCheckConsentProgress
